import React from 'react';
import { Suggestion } from '../../models/chatbot/types';
import './chat-suggestions.scss';

interface ChatSuggestionsProps {
  suggestions: Suggestion[];
  onSuggestionClick: (question: string) => void;
}

const ChatSuggestions: React.FC<ChatSuggestionsProps> = ({
  suggestions,
  onSuggestionClick,
}) => {
  return (
    <div className="chat-suggestions">
      <div className="chat-suggestions__grid">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="chat-suggestion-card"
            onClick={() => onSuggestionClick(suggestion.question)}
            type="button"
          >
            <span className="chat-suggestion-card__text">
              {suggestion.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatSuggestions;
